import { listSilobagsService, SilobagListFilter } from '@siloreal:shared:api/service/silobag/silobag-list';
import * as UI from '@siloreal:shared:ui';
import { SilobagRow } from '@siloreal:modules:private/silobag-list/config/extra/types';
import UTILS from '@siloreal:modules:private/silobag-list/config/extra/utils';
import { useSilobagListContext } from '../../../context';
import { TABLE_INTERACTIONS } from '../interactions';
import { toSilobagListContract } from '../service/adapter';
import { TABLE_COLUMNS, TABLE_PINNED_COLUMNS } from '../table-columns';
import { TABLE_FILTERS } from '../table-filters';

const implicitFilters: SilobagListFilter = {
  active: true,
  vrr: true,
};

const TABLE_ROW_STYLE_VARIANT: UI.TableProps['getRowStyleVariant'] = (row) => {
  const silobag = row as SilobagRow;

  if (UTILS.has.tag.insurance.active(silobag) || UTILS.has.tag.warranty.active(silobag)) return 'major';

  return 'spotlight';
};

export function ExplorerVRR() {
  const {
    organization: { current: organizationId },
    async: {
      list: { update },
      summary: {
        trigger: triggerSummary,
        loading: { start: startSummaryLoading, stop: stopSummaryLoading },
      },
    },
  } = useSilobagListContext();

  return (
    <UI.collection.explorer
      service={{
        fn: listSilobagsService,
        key: ['silopro-vrr-list', implicitFilters, organizationId],
        adapter: (state) => toSilobagListContract(state, { implicitFilters }),
        callback: {
          onTrigger: startSummaryLoading,
          onSuccess: (result, state) => {
            update(result.original);
            triggerSummary(toSilobagListContract(state, { implicitFilters }));
          },
          onError: stopSummaryLoading,
          dataAccess: (data) => data.data as UI.TableProps['rows'],
          rowCountAccess: (data) => data.total,
        },
      }}
      columns={TABLE_COLUMNS.SILOS_PRO.VRR}
      headerAction={TABLE_INTERACTIONS.SILOS_PRO.VRR}
      pinnedColumns={TABLE_PINNED_COLUMNS}
      getRowStyleVariant={TABLE_ROW_STYLE_VARIANT}
      searchbar
      tidPrefix="silopro-vrr-list"
    >
      {TABLE_FILTERS.SILOS_PRO.VRR}
    </UI.collection.explorer>
  );
}

/*
[MONDAY DAILY]
Frontend:
  - `explorer.tsx` has a property to adapt the internal state of an explorer to the service contract.
  - `service-selector.tsx` hasn't that property, so it is impossible to adapt the service response to the options expected by the selector.
  - I'm thinking in a solution to add that property to the `service-selector.tsx` component to allow mapping many options from service response to one option expected by the selector.
  - I can't test this implementantion and validate it because the endpoint `/tag_silobags` is not working as expected.
Backend:
  - I notice that the fix in the /tag_silobags endpoint is working weird.
  It returns an empty array with the user that Leo shared to me (boostaleqa@yopmail.com, Qa12345!) when it should return all the tags expected.
  I'm completely sure that the issue is still in the backend.
*/

/*
[FIXES VISUALES]
- Marcar el botón de interacción que haya seleccionado el usuario.
- Sacarle los textos a los botones de interacción de las listas, a excepción de 'Compartir'.
*/
